import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { StyledLargeText } from './large-text.styled';
var LargeText = function LargeText(_ref) {
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("596733928"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledLargeText, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.large_text_styles.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default LargeText;
